// js/custom-element/section/product/sticky-form.js
(function() {
  const init = function() {
    if (!window.customElements.get('product-sticky-form')) {
      var ProductStickyForm = class extends HTMLElement {
        connectedCallback() {
          var _a;
          (_a = document.getElementById(this.getAttribute("form-id"))) == null ? void 0 : _a.addEventListener("variant:changed", this._onVariantChanged.bind(this));
          this.imageElement = this.querySelector(".product-sticky-form__image");
          this.priceElement = this.querySelector(".product-sticky-form__price");
          this.unitPriceElement = this.querySelector(".product-sticky-form__unit-price");
          this._setupVisibilityObservers();
        }
        disconnectedCallback() {
          this.intersectionObserver.disconnect();
        }
        set hidden(value) {
          this.toggleAttribute("hidden", value);
          if (value) {
            document.documentElement.style.removeProperty("--cart-notification-offset");
          } else {
            document.documentElement.style.setProperty("--cart-notification-offset", `${this.clientHeight}px`);
          }
        }
        _onVariantChanged(event) {
          const variant = event.detail.variant, currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
          if (!variant) {
            return;
          }
          if (this.priceElement) {
            this.priceElement.innerHTML = window.formatMoney(variant["price"], currencyFormat);
          }
          if (this.unitPriceElement) {
            this.unitPriceElement.style.display = variant["unit_price_measurement"] ? "block" : "none";
            if (variant["unit_price_measurement"]) {
              let referenceValue = "";
              if (variant["unit_price_measurement"]["reference_value"] !== 1) {
                referenceValue = `<span class="unit-price-measurement__reference-value">${variant["unit_price_measurement"]["reference_value"]}</span>`;
              }
              this.unitPriceElement.innerHTML = `
              <div class="unit-price-measurement">
                <span class="unit-price-measurement__price">${window.formatMoney(variant["unit_price"])}</span>
                <span class="unit-price-measurement__separator">/</span>
                ${referenceValue}
                <span class="unit-price-measurement__reference-unit">${variant["unit_price_measurement"]["reference_unit"]}</span>
              </div>
            `;
            }
          }
          if (!this.imageElement || !variant || !variant["featured_media"]) {
            return;
          }
          const featuredMedia = variant["featured_media"];
          if (featuredMedia["alt"]) {
            this.imageElement.setAttribute("alt", featuredMedia["alt"]);
          }
          this.imageElement.setAttribute("width", featuredMedia["preview_image"]["width"]);
          this.imageElement.setAttribute("height", featuredMedia["preview_image"]["height"]);
          this.imageElement.setAttribute("src", window.getSizedMediaUrl(featuredMedia, "165x"));
          this.imageElement.setAttribute("srcset", window.getMediaSrcset(featuredMedia, [55, 110, 165]));
        }
        _setupVisibilityObservers() {
          const paymentContainerElement = document.getElementById("MainPaymentContainer"), footerElement = document.querySelector(".shopify-section--footer"), stickyHeaderOffset = window.getStickyHeaderOffset();
          this._isFooterVisible = this._isPaymentContainerPassed = false;
          this.intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.target === footerElement) {
                this._isFooterVisible = entry.intersectionRatio > 0;
              }
              if (entry.target === paymentContainerElement) {
                const boundingRect = paymentContainerElement.getBoundingClientRect();
                this._isPaymentContainerPassed = entry.intersectionRatio === 0 && boundingRect.top + boundingRect.height <= stickyHeaderOffset;
              }
            });
            if (window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
              this.hidden = !this._isPaymentContainerPassed || this._isFooterVisible;
            } else {
              this.hidden = !this._isPaymentContainerPassed;
            }
          }, { rootMargin: `-${stickyHeaderOffset}px 0px 0px 0px` });
          this.intersectionObserver.observe(paymentContainerElement);
          this.intersectionObserver.observe(footerElement);
        }
      };
      window.customElements.define("product-sticky-form", ProductStickyForm);
    }
  }
  if (window.criticalLoaded) { init() }
  else { document.addEventListener("critical-js:loaded", init); }
})();